import { createDefaultTyrann } from '@apis/common';
import { trackingData, trackingDataBody } from '@models/TrackingData';
import { formDataEncoder } from '@utils/types';
import * as t from 'io-ts';

export type TrackingDataBody = t.TypeOf<typeof trackingDataBody>;

export const trackingApis = createDefaultTyrann({
  '/tracking-data/list/': {
    get: {
      query: t.type({
        track_no: t.array(t.string),
      }),
      response: {
        200: t.array(trackingData),
      },
    },
  },
  '/tracking-data/{track_no}/': {
    get: {
      path: t.type({
        track_no: t.string,
      }),
      response: {
        200: trackingData,
        404: t.type({
          detail: t.string,
        }),
      },
    },
    patch: {
      path: t.type({
        track_no: t.string,
      }),
      body: trackingDataBody,
      response: {
        200: trackingData,
      },
      options: {
        bodyEncoder: formDataEncoder,
      },
    },
  },
});
